import React,{useEffect} from 'react'
export function Comp_Add_Employee(props){
  //alert(JSON.stringify(props.editUser));
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divAddEmployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xlll" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Add New Employee</h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmAddEmployee" name="frmAddEmployee">
       
        <div className="modal-body">
        <div className="row">
                  {/* <!-- left column --> */}
                  <div className="col-md-12">
                      <div className="card card-danger">
                              <input type="hidden" name="res_func" id="res_func" value={btoa("okRespCreateUser")} />
                              <input type="hidden" name="curl_type" id="curl_type" value={btoa("addUserInfo")} />
                              <input type="hidden" name="m_type" id="m_type" value={btoa("addUserInfo")} />
                              <input type="hidden" name="log_id" id="log_id" value={props.logUser[0]["id"]}/>
                              <input type="hidden" name="log_app_id" id="log_app_id" value={props.logUser[0]["app_user_id"]}/>
                              <input type="hidden" name="type_id" id="type_id" value="2" />
                              <input type="hidden" name="category_id" id="category_id" value={btoa("4")}/>
                              <input type="hidden" name="user_info_id" id="user_info_id" value={typeof props.editUser.id !=="undefined"?btoa(props.editUser.id):"0"}/>
                              
                              <div className="card-body">
                                <table>
                                    <tr>
                                        <td><label for="exampleInputEmail1">Employee Name</label></td>
                                        <td> <input type="text" id="contact_person" name="contact_person" className="form-control required" placeholder="" defaultValue={props.editUser.contact_person} /></td>
                                    </tr>
                                    <tr>
                                        <td><label for="exampleInputEmail1">Contact No</label></td>
                                        <td><input type="text" id="contact_no" name="contact_no" className="form-control required" placeholder="" defaultValue={props.editUser.contact_no} /></td>
                                    </tr>
                                    <tr>
                                        <td><label for="exampleInputEmail1">UserName</label></td>
                                        <td><input type="text" id="user_name" name="user_name" className="form-control required" placeholder="" defaultValue={props.editUser.user_name} /></td>
                                    </tr>
                                    <tr>
                                        <td><label for="exampleInputEmail1">Password</label></td>
                                        <td><input type="text" id="password" name="password" className="form-control required" placeholder="" defaultValue={props.editUser.password} /></td>
                                    </tr>
                                    <tr>
                                    <td><label for="exampleInputEmail1">Net Salary</label></td>
                                    <td><input type="text" id="net_salary" name="net_salary" className="form-control required" placeholder="" defaultValue={props.editUser["net_salary"]} /></td>
                                    </tr>
                                    
                                  
                                </table>
                                 
                                  <div className="col-md-6 respSSL"></div>
                                  <div id="testing2dd2222"></div>
                              </div>
                      </div>
                  </div>
              </div>
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" className="btn _btnSetColor btn-primary">Save</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Comp_Add_Employee;